$(function () {
  $('a[rel~=external]').attr('target', '_blank')
})
